import axios from 'axios';

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 10000
});
//获取tokennpm
function getTokenByLocal() {
    let token = localStorage.getItem("token") || "";
    return token;
}


service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        config.headers["Content-Type"] = "application/json;charset=UTF-8";
        if (getTokenByLocal()) {
            config.headers.Authorization = localStorage.getItem("token");
        }
        return config;
    },
    error => {
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
